// extracted by mini-css-extract-plugin
export default {"container":"ContentBox_container__UCB0l","box":"ContentBox_box__q1BdK","img":"ContentBox_img__XcBr0","text":"ContentBox_text__2A7ZW"};